export default "__VITE_ASSET__f999df98__"